export const WELCOME_PAGE_PRODUCTS_SEARCH_ID = 'welcome_page_products_search'
